import moment from 'moment';
import { MemberDetailsType } from '../features/settings/types';

const memberToUpdateParams = (formData: MemberDetailsType, inviterEmail: string, member: any) => {
  return {
    context: {
      intent: 'update household member',
      callback: 'http://callback..',
    },
    resource: {
      resourceType: 'Patient',
      identifier: [
        {
          system: 'http://proactivehealthtech.com/sid/d2md/v1/person/username',
          value: inviterEmail,
        },
      ],
    },
    patch: [
      {
        op: 'add',
        path: '/member',
        value: [
          {
            entity: member?.entity,
            relationship: {
              text: formData.relationship,
            },
            address: [
              {
                city: formData.city,
                country: formData.country,
                line: [formData.street ?? '', formData.unit ?? ''],
                postalcode: formData.zip,
                state: formData.state,
                use: 'home',
              },
            ],
            birthDate: moment(formData.birthdate).format('YYYY-MM-DD'),
            gender: formData.sex,
            name: [
              {
                family: formData.lastName,
                given: [formData.firstName, ...(formData.middleName ? [formData.middleName] : [])],
                use: 'usual',
              },
            ],
          },
        ],
      },
    ],
  };
};

export default memberToUpdateParams;
